module.exports = __webpack_public_path__ + "img/pic-3-2.869181a5.png";